import { ControlledAutocompleteDropdownLazy } from 'src/shared/components/form/controlledAutocompleteDropdownLazy';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { getSex } from 'src/shared/services/formSettingService';
import { useTranslation } from 'react-i18next';

export const MemberAdvancedSearchGender = () => {
  const isMounted = useIsMounted();
  const { t } = useTranslation(['common']);
  return (
    <ControlledAutocompleteDropdownLazy
      name='sex'
      componentWidth='100%'
      callback={(x) => ConsoleHelper.log(x)}
      fetchMethod={async () => {
        try {
          const result = await getSex();
          if (isMounted()) {
            const items = result.data.results[0].extraOptions.filter((x) => x.name !== '');
            return items;
          }
        } catch (e) {
          if (isMounted()) {
            ConsoleHelper.log(e);
          }
        }

        return [];
      }}
      nameProp='name'
      label={t('common:form.gender')}
    />
  );
};
